import { IHookFormProps } from '@/interfaces';
import { Controller, FieldValues, Path, UseControllerProps } from 'react-hook-form';
import { Input, InputProps } from '../ui';
import { cn } from '@/lib/utils';

type TProps<TFieldValues extends FieldValues> = IHookFormProps<TFieldValues> & InputProps;

const ControlledInput = <TFieldValues extends FieldValues>(props: TProps<TFieldValues>) => (
  <Controller
    name={props.name as Path<TFieldValues>}
    control={props.control}
    rules={props.rules as UseControllerProps<TFieldValues>['rules']}
    defaultValue={props.defaultValue || ''}
    render={
      ({ field: { name: fieldName, onChange, onBlur, value }, fieldState: { error } }) => (
        <Input
          {...props}
          className={cn(
            props?.className,
            error && 'border-red-500 focus-visible:ring-transparent'
          )}
          title={
            error
              ? error.message
              : props.title
          }
          maxLength={props?.maxLength ?? 300}
          name={fieldName}
          onChange={
            e => {
              props.onChange?.(e);
              onChange(e);
            }
          }
          value={value ?? ''}
          onBlur={
            e => {
              props.onBlur?.(e);
              onBlur();
            }
          } />
      )
    }
  />
);

export default ControlledInput;
